import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

type Props = Readonly<{
  marbleUuid: string
  probabilities?: Record<string, number>
}>

export function MarblePaneOddsValue({ marbleUuid, probabilities }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  if (!probabilities) return null

  const probability = probabilities[marbleUuid] ?? 0.125
  const formattedProbability = (probability * 100).toFixed(2)

  return (
    <>
      <span className="marble-odds-value">{formattedProbability}%</span>
      <span className="marble-odds-label">{t('Chance')}</span>
    </>
  )
}
